__turbopack_context__.v({
  "card": "CardInternalLink-module-scss-module__Jl7ngG__card",
  "cardLinkWrap": "CardInternalLink-module-scss-module__Jl7ngG__cardLinkWrap",
  "fade-in": "CardInternalLink-module-scss-module__Jl7ngG__fade-in",
  "image": "CardInternalLink-module-scss-module__Jl7ngG__image",
  "linkBtn": "CardInternalLink-module-scss-module__Jl7ngG__linkBtn",
  "linkBtnIcon": "CardInternalLink-module-scss-module__Jl7ngG__linkBtnIcon",
  "text": "CardInternalLink-module-scss-module__Jl7ngG__text",
});
